import { render, staticRenderFns } from "./TepViajeIniciar.vue?vue&type=template&id=6f6f1cad"
import script from "./TepViajeIniciar.vue?vue&type=script&lang=js"
export * from "./TepViajeIniciar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports